import { render, staticRenderFns } from "./CityList.vue?vue&type=template&id=53cd1b9d"
import script from "./CityList.vue?vue&type=script&lang=js"
export * from "./CityList.vue?vue&type=script&lang=js"
import style0 from "./CityList.vue?vue&type=style&index=0&id=53cd1b9d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports